import { SHUFTI_STATUS, SHUFTI_VARIANTS } from './enums';
import { VerificationConfig } from './types';

export const SHUFTI = 'shufti';
export const TAG_NAME = 'risk/doc/Id_document_requirement';
export const SHUFTI_BOTTOM_CONTENT_ID = 'SHUFTI_BOTTOM_CONTENT';
export const VERIFICATION_STATUSES_DATA: VerificationConfig = {
    [SHUFTI_STATUS.REQUIRED]: {
        congratsSection: false,
        contentTranslation: 'documentsVerification.contentDefault',
        status: true,
        button: {
            disabled: false,
            variant: SHUFTI_VARIANTS.DEFAULT
        }
    },
    [SHUFTI_STATUS.PENDING]: {
        congratsSection: false,
        contentTranslation: 'documentsVerification.contentDefault',
        status: true,
        button: {
            disabled: true,
            variant: SHUFTI_VARIANTS.DEFAULT
        }
    },
    [SHUFTI_STATUS.MANUAL]: {
        congratsSection: false,
        contentTranslation: 'documentsVerification.contentManual',
        status: true,
        button: {
            disabled: false,
            variant: SHUFTI_VARIANTS.EMAIL
        }
    },
    [SHUFTI_STATUS.VERIFIED]: {
        congratsSection: true,
        contentTranslation: 'documentsVerification.contentVerified',
        status: true,
        button: null
    },
    [SHUFTI_STATUS.INVALID]: {
        congratsSection: false,
        contentTranslation: 'documentsVerification.contentManual',
        status: false,
        button: {
            disabled: false,
            variant: SHUFTI_VARIANTS.EMAIL
        }
    }
};
